import { Locale } from '@1inch-community/models';
import { BehaviorSubject, map } from 'rxjs';
import { isRTL } from './locale';
export const defaultLocaleCode = getDefaultLocaleCode();
const translations = new Map();
const currentTranslations$ = new BehaviorSubject(null);
let defaultTranslations;
let currentTranslations;
let currentLocaleCode = Locale.en;
let lastDefaultTranslationsStorageSize = 0;
let lastCurrentTranslationsStorageSize = 0;
let targetHost = document.querySelector('html');
export const localeChange$ = currentTranslations$.pipe(map(() => currentLocaleCode));
export function setTargetHost(host) {
    targetHost = host;
}
export async function addTranslation(translationsRecord) {
    for (const localeCode in translationsRecord) {
        const translation = Reflect.get(translationsRecord, localeCode);
        const storage = translations.get(localeCode) ?? [];
        storage.push(translation);
        translations.set(localeCode, storage);
    }
    await updateLocaleAndTranslations(currentLocaleCode);
}
export async function changeLocaleAndUpdate(localeCode) {
    await updateLocaleAndTranslations(localeCode);
}
export function listenChangesByPath(path, context) {
    return currentTranslations$.pipe(map((translations) => {
        if (!translations)
            return '';
        const result = translations[path] ?? '';
        if (context && result.includes('{{') && result.includes('}}')) {
            return interpolateString(result, context);
        }
        return result;
    }));
}
function interpolateString(value, context) {
    let newValue = value;
    for (const key in context) {
        const contextValue = context[key];
        const pattern = `{{${key}}}`;
        newValue = newValue.replaceAll(pattern, `${contextValue}`);
    }
    return newValue;
}
const translationsListToRecord = (translationsList) => translationsList.reduce((record, translations) => ({ ...record, ...translations }), {});
async function updateLocaleAndTranslations(newLocaleCode) {
    targetHost.dir = isRTL(newLocaleCode) ? 'rtl' : 'ltr';
    await Promise.all([updateDefaultTranslationsMap(), updateCurrentTranslationsMap(newLocaleCode)]);
    currentLocaleCode = newLocaleCode;
    targetHost.lang = newLocaleCode;
}
async function updateDefaultTranslationsMap() {
    const defaultTranslationsByLocale = translations.get(defaultLocaleCode) ?? [];
    if (defaultTranslationsByLocale.length !== lastDefaultTranslationsStorageSize) {
        const translationsList = await Promise.all(defaultTranslationsByLocale.map((fn) => fn()));
        defaultTranslations = translationsListToRecord(translationsList);
        currentTranslations$.next({ ...defaultTranslations, ...currentTranslations });
        lastDefaultTranslationsStorageSize = defaultTranslationsByLocale.length;
    }
}
async function updateCurrentTranslationsMap(newLocaleCode) {
    const translationsByLocale = translations.get(newLocaleCode) ?? [];
    if (currentLocaleCode !== newLocaleCode ||
        translationsByLocale.length !== lastCurrentTranslationsStorageSize) {
        const translationsList = await Promise.all(translationsByLocale.map((fn) => fn()));
        currentTranslations = translationsListToRecord(translationsList);
        currentTranslations$.next({ ...defaultTranslations, ...currentTranslations });
        lastCurrentTranslationsStorageSize = translationsByLocale.length;
    }
}
export function isRTLCurrentLocale() {
    return isRTL(currentLocaleCode);
}
function getDefaultLocaleCode() {
    try {
        const userLocale = navigator.language || navigator.userLanguage;
        const code = userLocale.slice(0, 2);
        if (!(code in Locale))
            return Locale.en;
        return code;
    }
    catch {
        return Locale.en;
    }
}
Reflect.set(window, 'changeLocale', changeLocaleAndUpdate);
//# sourceMappingURL=i18n.js.map